import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';

export interface PasswordRequirementsProps {
  password: string;
}

/** Mirrors `passwordSchema` (`src/shared/validation/authSchemas.ts`) rule-for-rule, so a client-side
 * checklist item goes green at exactly the moment the backend validator would also accept it. */
const REQUIREMENTS: Array<{ label: string; test: (password: string) => boolean }> = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'An uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'A lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'A digit', test: (p) => /\d/.test(p) },
  { label: 'A special character', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  return (
    <List dense disablePadding>
      {REQUIREMENTS.map(({ label, test }) => {
        const met = test(password);
        return (
          <ListItem key={label} disablePadding disableGutters>
            <ListItemIcon sx={{ minWidth: 28 }}>
              {met ? (
                <CheckCircleIcon fontSize="small" color="success" />
              ) : (
                <RadioButtonUncheckedIcon fontSize="small" color="disabled" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={label}
              slotProps={{
                primary: { variant: 'caption', color: met ? 'text.primary' : 'text.secondary' },
              }}
            />
          </ListItem>
        );
      })}
    </List>
  );
}
